import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import * as _ from 'lodash';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ModalComponent } from '../../modal/modal.component';

@Component({
    templateUrl: './templates-modal.component.html',
    standalone: false
})
export class InspectionModelTemplatesModalComponent extends BaseModalPageComponent {
  models: any[];

  constructor(public selfModal: ModalComponent, location: Location, public cdRef: ChangeDetectorRef) {
    super(location);
  }

  public init(data: any) {
    Object.assign(this, data);
  }

  selectModel(model: any) {
    model.selected = !model.selected;
  }

  save() {
    this.selfModal.close(this.models.filter((m) => m.selected).map((m) => m.id));
  }

  cancel() {
    this.selfModal.close(false);
  }
}
